import React from "react";
import { View, Text } from "react-native";
import { styles } from "../../style/styles.js";
import { BORDER_COLORS } from "../../style/colors.js";

export default function CustomTableHeader({ columns }) {
  return (
    <View
      style={{
        flexDirection: "row",
        borderBottomWidth: 3,
        borderColor: BORDER_COLORS.DARK, //"#174045",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}>
      {columns.map((column) => (
        <View key={column.name} style={{ width: column.width }}>
          <Text
            style={[
              styles.textHeader,
              styles.textColor,
              { textAlign: "center" },
            ]}>
            {column.name}
          </Text>
        </View>
      ))}
    </View>
  );
}
